import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/utils/lib/axios";

type DocumentMappingEntry = {
  fieldPath?: string;
  fieldName?: string;
  fieldIsRevise?: boolean;
};

type SupportingDocumentData = {
  id: string;
  documentMappings?: Record<string, DocumentMappingEntry>;
  abdDariKmzName: string;
  abdDariKmzPath: string;
  abdDariKmzIsRevise: boolean;
  abdDariDwgName: string;
  abdDariDwgPath: string;
  abdDariDwgIsRevise: boolean;
  abdDwgName: string;
  abdDwgPath: string;
  abdDwgIsRevise: boolean;
  evidenceFeederName: string;
  evidenceFeederPath: string;
  evidenceFeederIsRevise: boolean;
  bakpName: string;
  bakpPath: string;
  bakpIsRevise: boolean;
  cmldName: string;
  cmldPath: string;
  cmldIsRevise: boolean;
  clampHookName: string;
  clampHookPath: string;
  clampHookIsRevise: boolean;
  evidenceOltName: string;
  evidenceOltPath: string;
  evidenceOltIsRevise: boolean;
  statusFeederAndOlt: string;
};

interface SupportingDocumentQueryKey {
  rfsId?: string;
}

async function getSupportingDocumentByRfsId(
  queryFunctionContext: QueryFunctionContext,
): Promise<SupportingDocumentData> {
  const { queryKey } = queryFunctionContext;
  const [_, supportingDocumentQueryKey] = queryKey;
  const { rfsId } = supportingDocumentQueryKey as SupportingDocumentQueryKey;

  const response = await axiosInstance.get(
    `/api/crud/supporting-document?rfs.id=${rfsId ?? ""}`,
  );

  return response.data.data.content[0];
}

function useSupportingDocumentByRfsId(
  supportingDocumentQueryKey: SupportingDocumentQueryKey = {},
  options?: {
    enabled?: boolean;
  },
) {
  return useQuery({
    ...options,
    queryKey: ["supporting-documents", supportingDocumentQueryKey],
    queryFn: getSupportingDocumentByRfsId,
  });
}

export type { SupportingDocumentData };
export { useSupportingDocumentByRfsId };
